import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryButtons from './components/CategoryButtons';
import ProductsShowcase from './components/ProductsShowcase';
import ValueProposition from './components/ValueProposition';
import HowItWorks from './components/HowItWorks';
import ComparisonTable from './components/ComparisonTable';
import CommercialCards from './components/CommercialCards';
import SafetySection from './components/SafetySection';
import ArticlesSection from './components/ArticlesSection';
import FAQSection from './components/FAQSection';
import CTABanner from './components/CTABanner';

export default function Home() {
  const heroBg = 'https://readdy.ai/api/search-image?query=Fashion%20ecommerce%20flat%20lay%20with%20sneakers%2C%20hoodies%2C%20denim%2C%20caps%20and%20accessories%20arranged%20as%20a%20creative%20overhead%20grid%20on%20a%20warm%20cream%20textured%20background%2C%20soft%20directional%20lighting%2C%20editorial%20streetwear%20product%20photography%2C%20earthy%20neutral%20beige%20and%20olive%20tones%2C%20high%20detail%2C%20balanced%20airy%20composition&width=1600&height=900&seq=hero-bg-v2&orientation=landscape';

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection bgImage={heroBg} />
        <CategoryButtons />
        <ProductsShowcase />
        <ValueProposition />
        <HowItWorks />
        <ComparisonTable />
        <CommercialCards />
        <SafetySection />
        <ArticlesSection />
        <FAQSection />
        <CTABanner />
      </main>
      <Footer />
    </div>
  );
}